<template>
    <div>
        <b-modal id="documentTypeModal" title="tipo de documento" class="" size="xl" centered scrollable
            header-bg-variant="dark" v-model="modalShow" hide-footer>


            <template #modal-header="{ close }">
                <!-- Emulate built in modal header close button action -->
                <b-button size="sm" variant="outline-warning" @click="close()">
                    Cerrar
                </b-button>

            </template>

            <!-- cuerpo -->
            <b-table :busy="isBusy" :fields="fields" :items="filteredItems" sticky-header responsive no-border-collapse
                select-mode="single" selectable @row-selected="onRowSelected" show-empty>
                <template #empty>
                    <b-card v-if="items.length !== 0" class="text-center my-2 fs-5">
                        No hay tipos de documento que coincidan con los criterios de búsqueda
                    </b-card>
                    <b-card v-else class="text-center my-2 fs-5">
                        Aún no se ha agregado ningún tipo de documento
                    </b-card>
                </template>

                <!-- Icono de carga de tabla -->
                <template #table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Cargando datos de tabla...</strong>
                    </div>
                </template>

            </b-table>

        </b-modal>
    </div>
</template>
<script>
export default {
    name: 'DocumentTypeModal',

    data() {
        return {
            modalShow: false,
            isBusy: false,
            items: [],
            fields: [
                { key: 'name', label: 'Documento' },
                { key: 'confidential', label: 'Confidencial' },
                { key: 'typeName', label: 'Tipo de documento' },
            ],
        }
    },

    computed: {
        filteredItems() {
            let filtered = this.items;

            // Filtrar por búsqueda por nombre, apellido, etc.

            return filtered;
        },
    },

    methods: {
        openModal(documents, type) {
            this.items = this.map(documents, type);
            this.modalShow = true;
        },

        closeModal() {
            this.modalShow = false;
        },

        onRowSelected(items) {
            this.selected = items;
        },

        map(documents, type) {
            return documents
                .map((d) => {
                    return {
                        name: d.name,
                        confidential: this.formatBoolean(d.confidential),
                        typeName: d.type.name
                    }
                })
                .filter(d => d.typeName == type);
        },

        formatBoolean(value){
            if(value === true){
                return 'Si'
            }
            else{
                return 'No'
            }
        },
    }

}
</script>
<style></style>